import * as React from 'react';

const HeaderLayoutLeft = (props) => {
  return (
    <div className="m__head__left">
      {props.children}
    </div>
  )
};

export default HeaderLayoutLeft;
